/// <amd-module name="typeahead/dataprovider/IClientSideCacheStatusChecker" />

export interface IClientSideCacheStatusChecker {
    isClientSideCacheDisabled(context: IContext): Boolean;
}

export const isClientSideCacheDisabled: IPluginIdentifier = (plugin: Object): boolean => {
    return (typeof plugin === "object")
        && (typeof (plugin as IClientSideCacheStatusChecker).isClientSideCacheDisabled === "function");
};
